import { CommonMessages } from 'src/messages/validationMessages';
import * as Yup from 'yup';

export const updatePaymentSchema = Yup.object().shape({
    paymentMethodId: Yup.string().required("payment Method Id Required"),
    action: Yup.string().required("Action Required"),
    exp_month: Yup.number()
        .required(CommonMessages.exp_month_required)
        .min(1, CommonMessages.month_linit)
        .max(12, CommonMessages.month_linit),
    exp_year: Yup.number()
        .required(CommonMessages.exp_year_required)
        .min(new Date().getFullYear(), CommonMessages.future_date_needed)
        .test(
            'is-valid-expiration',
            CommonMessages.future_date_needed,
            function (exp_year) {
                const { exp_month } = this.parent;
                const currentYear = new Date().getFullYear();
                const currentMonth = new Date().getMonth() + 1; // Months are 0-indexed

                if (exp_year > currentYear) {
                    return true;
                }
                if (exp_year === currentYear) {
                    return exp_month >= currentMonth;
                }
                return false;
            }
        ),
});
